import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-manage-seat-list-page',
  templateUrl: './manage-seat-list-page.component.html',
  styleUrls: ['./manage-seat-list-page.component.scss']
})
export class ManageSeatListPageComponent implements OnInit {

  @Input() id: string;
  public selectedCampaignId;
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.selectedCampaignId = params.get('campaignId');
    });
    window['$']('#seat-list').on("click", "a[id^='editSeat_']", (event) => {
      const [, id] = event.currentTarget.id.split("_");
      const table = window['ticketingAndGuestsModal'].eventTable
      const seats = table.seats || [];
      const seat = seats.find(seat => seat.id == id) || {
        id:null,
        seatName:null
      };

      window['ticketingAndGuestsModal'].openSeatsModal(seat, true).then((newSeat) => {
        return window['ticketingAndGuestsModal'].updateTableSeat(table.id, newSeat);
      }).then(() => {
        window['orgMain'].showManageTableSeatList(table.id)
      },() => {})
    })

    window['$']('#seat-list').on("click", "a[id^='deleteSeat_']", (event) => {
      const [, tableId, seatId] = event.currentTarget.id.split("_");
  
      window['orgMain'].confirmDialogSimple({
          title: "Are you sure?",
          message: `Delete this Seat.`,
          yes: function() {
            window['orgMain'].deleteTableSeat(tableId, seatId).then(() => {
              window['orgMain'].showManageTableSeatList(tableId);
            })
          },
          no: function() {
          }
      });
    })
  }

  openSeatsModal(){
    return window['ticketingAndGuestsModal'].openSeatsModal({
      id:null,
      seatName:null
    }).then(({ seatName }) => {
      return window['orgMain'].addNewTableSeat({
        id: this.id
      }, { seatName });
    }).then(() => {
      return window['orgMain'].showManageTableSeatList(this.id);
    }, () => {});
  }

  ngAfterViewInit(): void {
    window['orgMain'].showManageTableSeatList(this.id)
  }
}
